﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../utilities/crud-functions';
import { HplcImpurity } from '../models/hplc-impurity';
import { EditType, MessageBoxReplyType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import { ToastProps } from '../models/toast-props';

import { Toast } from 'devextreme-react/toast';
import { Button } from 'devextreme-react/button';
import Guid from 'devextreme/core/guid';

import { ReactGrid, Id, CellChange, TextCell, Column, Row, Range, DefaultCellTypes } from "@silevis/reactgrid";

import "@silevis/reactgrid/styles.css";
import { MessageBoxReply } from '../models/message-box-reply';

const HPLC_IMPURITY_ID_COLUMN_IDX = 0;
const EDIT_TYPE_COLUMN_ID = "editType";
const UNSAVED_CHANGES_WARNING = 100;

const initColumns: Column[] = [
    { columnId: "hplcImpurityDataId", width: -20 },
    { columnId: EDIT_TYPE_COLUMN_ID, width: -20 },
    { columnId: "elution", width: 70 },
    { columnId: "impurity", width: 180, resizable: true },
    { columnId: "result", width: 125, resizable: true },
    { columnId: "retentionTime", width: 125, resizable: true },
];

const headerRow: Row = {
    rowId: "header",
    cells: [
        { type: "header", text: "", className: "reactgrid-hidden-column" },
        { type: "header", text: "", className: "" },
        { type: "header", text: "Elution", className: "reactgrid-header-cell" },
        { type: "header", text: "Impurity", className: "reactgrid-header-cell" },
        { type: "header", text: "Result", className: "reactgrid-header-cell" },
        { type: "header", text: "Retention Time", className: "reactgrid-header-cell" },
    ]
};

let key = 1;
let newIdx = 1;

export interface Props {
    benchSheetId: string;
    onClose?: () => void;
}

export default function HplcImpuritiesComponent(props: Props) {
    const [impurities, setImpurities] =
        useState<HplcImpurity[]>();

    const [selectedImpurityId, setSelectedImpurityId] =
        useState<string>();

    const [rows, setRows] =
        useState<Row[]>();

    const [columns, setColumns] =
        useState<Column[]>(initColumns);

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    key++;

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getRows();
    }, [impurities]);

    return (
        <div>
            <div className="pw-comp-row pw-margin-top-05">
                <div className="title-bar-spacer" />
                <div className="save-toolbar pw-margin-right-05">

                    <Button text="Add Row" icon="plus" type="success"
                        className="pw-button" height='1.8rem'
                        hint="add row"
                        onClick={onAddRowClick} />

                    <Button id="saveButton" text="Save" icon="save" type="success"
                        className="pw-button"
                        hint="save changes"
                        height='1.8rem'
                        onClick={onSaveClick} />

                    <Button id="closeButton" text="Close" icon="close" type="normal"
                        className="pw-button"
                        hint="close dialog"
                        height='1.8rem'
                        onClick={onCloseClick} />
                </div>
            </div>

            <div className="pw-margin-top-1">
                <ReactGrid
                    enableFillHandle={true}
                    enableRangeSelection={true}
                    rows={rows ? rows : []} columns={columns}
                    onSelectionChanging={onSelectionChanging}
                    onColumnResized={handleColumnResize}
                    onCellsChanged={handleChanges} />
            </div>

            {/* 
                TODO:
             <Summary>
                        <TotalItem column="result"
                            displayFormat="Total HPLC Impurities: {0}"
                            valueFormat={{ type: "fixedPoint", precision: 4 }}
                            summaryType="sum" />
                    </Summary>
            */}


            {/*
            <div className="pw-datagrid">
                <DataGrid
                    width="100%"
                    height={"80vh"}
                    keyExpr="hplcImpurityDataId"
                    wordWrapEnabled={true}
                    dataSource={impurities ? impurities : []}
                    onSelectionChanged={onSelectionChanged}
                    onRowValidating={onHplcImpuritiesValidating}
                    onRowRemoving={onHplcImpuritiesRowRemoving}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <LoadPanel enabled={true} />
                    <Selection mode={'single'} />
                    <Paging enabled={false} />

                    <Column name="bc0" type="buttons" width='4rem'>
                        <ColumnButton hint="delete" icon="trash"
                            onClick={onHplcImpuritiesRowRemoving} />
                        <ColumnButton hint="certificate" icon="info"
                            onClick={onImpuritiesInfoButtonClick} />
                    </Column>

                    <Column width='2rem' cssClass="table-vertical-align"
                        cellRender={editMarkerCellRender} />

                    <Column dataField={'elution'} dataType="number" width={'8rem'} alignment='center' />
                    <Column dataField={'impurity'} width={'50%'} />
                    <Column dataField={'result'} dataType="number" format={decimalFormat} width={'25%'} />
                    <Column dataField={'retentionTime'} dataType="number" format={decimalFormat} width={'25%'} />
                    <Column width="5rem" />

                    <Summary>
                        <TotalItem column="result"
                            displayFormat="Total HPLC Impurities: {0}"
                            valueFormat={{ type: "fixedPoint", precision: 4 }}
                            summaryType="sum" />
                    </Summary>

                    <Toolbar>
                        <ToolBarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Impurities</div>
                            </div>
                        </ToolBarItem>

                        <ToolBarItem location='after'>
                            <Button width='1.9rem' type='normal' icon="repeat"
                                hint="duplicate rows"
                                onClick={onDuplicateHplcImpurityRow} />
                        </ToolBarItem>

                        <ToolBarItem location='after'>
                            <Button width='1.9rem' type='normal' icon="plus"
                                hint="add analysis data row" 
                                onClick={onAddHplcImpurityRowClick} />
                        </ToolBarItem>

                    </Toolbar>

                    <Editing mode="cell"
                        useIcons={true}
                        allowAdding={true}
                        allowUpdating={true}
                        allowDeleting={true} />
                </DataGrid>
            </div>
            */}

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata}
                    onReply={onGlobalDialogReply} onClose={onGlobalDialogClose} />
            }

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

        </div>
    );

    function handleColumnResize(ci: Id, width: number) {
        if (!columns)
            return;

        setColumns((prevColumns) => {
            const columnIndex = prevColumns.findIndex(el => el.columnId === ci);
            const resizedColumn = prevColumns[columnIndex];
            const updatedColumn = { ...resizedColumn, width };
            prevColumns[columnIndex] = updatedColumn;
            return [...prevColumns];
        });
    }

    function onAddRowClick() {
        let elutionNumber = 1;

        if (impurities)
            elutionNumber = impurities.length + 1;

        let editedImpurities = [...impurities];
        let newImpurity: HplcImpurity = { hplcImpurityDataId: new Guid().toString(), elution: elutionNumber, editType: EditType.Insert };
        editedImpurities.push(newImpurity);

        setImpurities(editedImpurities);
    }

    function onSelectionChanging(selectedRanges: Range[]): boolean {
        //console.log("onSelectionChanging");
        //console.log(selectedRanges);

        if (selectedRanges && selectedRanges.length > 0 &&
            selectedRanges[0].columns && selectedRanges[0].columns.length > 0 &&
            selectedRanges[0].rows && selectedRanges[0].rows.length > 0) {

            //const rowId = selectedRanges[0].rows[0].rowId;

            const selectedImpurityIdCell = selectedRanges[0].first.row.cells[HPLC_IMPURITY_ID_COLUMN_IDX] as any;
            const selectedImpurityId = selectedImpurityIdCell.text;

            setSelectedImpurityId(selectedImpurityId);
        }

        return true;
    }

    function handleChanges(changes: CellChange<TextCell>[]) {
        setImpurities((prevImpurities) => applyChangesToImpurities(changes, prevImpurities));
    };

    function applyChangesToImpurities(changes: CellChange<TextCell>[], prevImpurities: HplcImpurity[]): HplcImpurity[] {
        //console.log("changes:");
        //console.log(changes);

        changes.forEach((change) => {
            const impurityIndex = change.rowId;
            const fieldName = change.columnId;

            prevImpurities[impurityIndex][fieldName] = change.newCell.text;

            if (prevImpurities[impurityIndex].editType !== EditType.Insert)
                prevImpurities[impurityIndex].editType = EditType.Update;
        });

        return [...prevImpurities];
    };


    /* TODO
    function onDuplicateHplcImpurityRow() {
        if (selectedImpurity) {

            let editedHplcImpurities = [...impurities];
            let newHplcImpurity = { ...selectedImpurity };

            newHplcImpurity.editType = EditType.Insert;

            editedHplcImpurities.push(newHplcImpurity);

            editedHplcImpurities.sort((a, b) => a.elution - b.elution);

            setImpurities(editedHplcImpurities);
        }
    }
    */

   /*
    function onSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedImpurity(e.selectedRowsData[0]);
        }
    }

    async function onHplcImpuritiesValidating(e: any) {
        if (e.oldData && e.oldData.editType !== EditType.Insert)
            e.newData.editType = EditType.Update;
    }

    function onHplcImpuritiesRowRemoving(e: any) {
        console.log("onHplcImpuritiesRowRemoving");
        console.log(e);

        if (e.row && e.row.data && e.row.data.hplcImpurityDataId) {
            let editedHplcImpurities = [...impurities];

            let matchingHplcImpurity = editedHplcImpurities.find(i => i.hplcImpurityDataId === e.row.data.hplcImpurityDataId);

            if (matchingHplcImpurity) {
                //if element was just added but not saved, just get rid of it
                if (matchingHplcImpurity.editType === EditType.Insert) {
                    const idx = editedHplcImpurities.findIndex(i => i.hplcImpurityDataId === e.row.data.hplcImpurityDataId);

                    if (typeof idx === 'number')
                        editedHplcImpurities.splice(idx, 1);
                }
                else {
                    matchingHplcImpurity.editType = EditType.Delete;
                }

                setImpurities(editedHplcImpurities);
            }
        }
    }
    */

    function onSaveClick() {
        saveHplcImpurities();
    }

    function onCloseClick() {
        const anyNonSavedChanges = impurities.some(a => a.editType !== EditType.None);

        if (anyNonSavedChanges) {
            showPromptMessage(ModalMessageType.PromptYesNo,
                "Unsaved Items",
                "You have unsaved changes. Do you want to close anyway?",
                UNSAVED_CHANGES_WARNING);

            return;
        }

        closeDialog();
    }

    async function closeDialog() {
        if (props.onClose)
            props.onClose();
    }

    async function saveHplcImpurities() {
        if (!impurities)
            return;

        let preparedImpurities = [...impurities];

        preparedImpurities.forEach(i => {
            i.benchSheetId = props.benchSheetId;

            //get rid of temporary keys
           // if (i.hplcImpurityDataId.length < 5)
             //   i.hplcImpurityDataId = null;
        });

        console.log("preparedImpurities...");
        console.log(preparedImpurities);

        await updateHplcImpurities(preparedImpurities)
            .then((data) => {
                showToast("Impurities Saved", "success");
                getHplcImpurities();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Updating Impurities");
            });
    }

    /*
    function onImpuritiesInfoButtonClick(e: any) {
        if (e.row && e.row.data && impurities) {
            let entry = impurities.find(p => p.hplcImpurityDataId === e.row.data.hplcImpurityDataId);

            if (entry) {

                let itemBasicInitInformation: ItemBasicInformation = {
                    rowPointer: entry.hplcImpurityDataId,
                    createTimestamp: entry.createTimestamp,
                    lastModifiedTimestamp: entry.modifyTimestamp,
                    createUser: entry.createUser,
                    modifyUser: entry.modifyUser
                };

                setItemBasicInitInformation(itemBasicInitInformation);
                setItemBasicInformationDialogVisible(true);
            }
        }
    }

    //show/hide

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }
    */


    async function getHplcImpurities() {
        await CrudFunctions.getData(`benchsheets/hplcimpuritiesbybenchsheetid/${props.benchSheetId}`)
            .then((data) => {
                setImpurities(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Impurities");
            });
    }

    async function updateHplcImpurities(impurities: HplcImpurity[]) {
        return await CrudFunctions.putData(`benchsheets/hplcimpurities/${props.benchSheetId}`, impurities)
       }

    async function getAllData() {
        await getHplcImpurities();
    }

    function getRows() {
        let createdRows: Row[] = [];

        if (impurities) {
            createdRows = [
                headerRow,
                ...impurities.map<Row<DefaultCellTypes>>((impurity, idx) => ({
                    rowId: idx,
                    cells: [
                        { type: "text", text: impurity.hplcImpurityDataId ? impurity.hplcImpurityDataId : "", nonEditable: true, className: "reactgrid-hidden-column" },
                        { type: "text", text: "", nonEditable: true, className: getEditTypeTemplate(impurity) },
                        { type: "text", text: impurity.elution ? impurity.elution.toString() : "", className: "reactgrid-cell pw-bold reactgrid-horizontal-center" },
                        { type: "text", text: impurity.impurity ? impurity.impurity : "", className: "reactgrid-cell" },
                        { type: "text", text: impurity.result ? impurity.result.toString() : "", className: "reactgrid-cell" },
                        { type: "text", text: impurity.retentionTime ? impurity.retentionTime.toString() : "", className: "reactgrid-cell" },
                    ]
                }))
            ];
        }
        else {
            let newImpurities: HplcImpurity[] = [];
            newImpurities.push({ hplcImpurityDataId: new Guid().toString(), elution: 1, editType: EditType.Insert });

            setImpurities(newImpurities);
        }

        setRows(createdRows);
    }

    //render
        
    function getEditTypeTemplate(impurity: HplcImpurity) {
        switch (impurity.editType) {
            case EditType.None:
                return "";
            case EditType.Insert:
                return "reactgrid-add-icon";
            case EditType.Update:
                return "reactgrid-edit-icon";
            case EditType.Delete:
                return "reactgrid-delete-icon";
        }
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showPromptMessage(mode: ModalMessageType, title: string, message: string, code: number) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message,
            code: code
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function onGlobalDialogReply(reply: MessageBoxReply) {
        if (reply.code === UNSAVED_CHANGES_WARNING) {
            clearGlobalDialog();

            if (reply.reply !== MessageBoxReplyType.Yes)
                return;

            closeDialog();
        }
    }

    function onGlobalDialogClose() {
        clearGlobalDialog();
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}